import { useLiveQuery } from "dexie-react-hooks";

export type Loading = {
  isLoading: boolean;
};

export function useAppLiveQuery<T>(
  querier: () => Promise<T> | T,
  deps: any[]
): {
  result: T | undefined;
  isLoading: boolean;
} {
  const result = useLiveQuery<T, Loading>(querier, deps, { isLoading: true });

  //   console.log(result, deps, (result as Loading)?.isLoading);

  return {
    result: ((result as Loading)?.isLoading ? undefined : result) as
      | T
      | undefined,
    isLoading: (result as Loading)?.isLoading === true,
  };
}
